import { useEffect } from "react";
import WebSocketManager from "./client.js";

export function useAdminPreferencesUpdates({ fetchPreferences, clientCode }) {
    useEffect(() => {
        if (!clientCode) return;

        const topic = `/topic/clients/${clientCode}/preferences`;

        const callback = () => {
            fetchPreferences(true);
        };

        WebSocketManager.subscribe(topic, callback);

        return () => {
            WebSocketManager.unsubscribe(topic);
        };
    }, [fetchPreferences, clientCode]);
}